import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ownerAPI from "../../../services/ownerApi";
import { OwnerPage, OwnerPanel, OwnerState } from "./OwnerPage";
import s from "./ownerCabinet.module.css";
import L from "../../../constants/baysportLabels";
import {
  formatDateRu,
  formatRub,
  paymentStatusLabel,
} from "./OwnerShell";

export default function OwnerPayments() {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      setError("");
      try {
        const res = await ownerAPI.listPayments(50);
        if (!cancelled) setPayments(res.payments || []);
      } catch (e) {
        if (!cancelled) {
          setError(
            e.response?.data?.error || "Не удалось загрузить историю платежей",
          );
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <OwnerPage
      title="История платежей"
      subtitle={`Все оплаты подписки ${L.productName} по вашим клубам.`}
    >
      {loading ? <OwnerState variant="loading">Загрузка…</OwnerState> : null}
      {error ? <OwnerState variant="error">{error}</OwnerState> : null}

      {!loading && !error && payments.length === 0 ? (
        <OwnerState variant="muted">
          Платежей пока нет.{" "}
          <Link to="/account/billing" className={s.linkAccent}>
            Перейти к оплате
          </Link>
        </OwnerState>
      ) : null}

      {!loading && payments.length > 0 ? (
        <OwnerPanel>
          {payments.map((row) => (
            <div key={row.id} className={s.paymentRow}>
              <div>
                <div className={s.paymentAmount}>{formatRub(row.amount)}</div>
                <div className={s.paymentMeta}>
                  {row.tenant?.name || "Клуб"} ·{" "}
                  {row.billing_period === "yearly" ? "год" : "месяц"}
                </div>
                <div className={s.paymentMeta}>
                  {formatDateRu(row.confirmed_at || row.created_at)}
                </div>
              </div>
              <span
                className={`${s.badge} ${
                  row.status === "confirmed"
                    ? s.badgeActive
                    : row.status === "pending"
                      ? s.badgeTrial
                      : s.badgeExpired
                }`}
              >
                {paymentStatusLabel(row.status)}
              </span>
            </div>
          ))}
        </OwnerPanel>
      ) : null}
    </OwnerPage>
  );
}
